module.exports = __webpack_public_path__ + "img/temoignage-6-rounded.638ff4d8.jpg";